import { FC, useEffect, useState } from "react";
import ScrollToTopArrowSVG from "../svg/functional/ScrollToTopArrowSVG";

const ScrollToTopButton: FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > window.innerHeight);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div
            onClick={scrollToTop}
            className={`fixed flex items-center justify-center z-10 w-[60px] dmax2:w-[50px] h-[60px] dmax2:h-[50px] bottom-10 dmax2:bottom-5 right-10 dmax2:right-5 bg-backgroundButton hover:bg-backgroundInput rounded-full transition-all duration-300 cursor-pointer group ${
                isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
        >
            <ScrollToTopArrowSVG className="text-textFaded group-hover:text-textWhite transition-all duration-300" />
        </div>
    );
};

export default ScrollToTopButton;
